/* eslint-disable import/prefer-default-export */
export function getBrowser() {
  if (navigator.userAgent.match(/Android/i)) {
    return 'Android';
  }
  if (navigator.userAgent.match(/webOS/i)
  || navigator.userAgent.match(/iPhone/i)
  || navigator.userAgent.match(/iPad/i)
  || navigator.userAgent.match(/iPod/i)) {
    return 'iOS';
  }

  return null;
}
